import { useReducedMotion } from './useReducedMotion';

/** Только системная настройка «уменьшить движение». Без импорта framer-motion. */
export function useEffectiveReducedMotion(): boolean {
  return useReducedMotion();
}
